import { ErrorCodes } from '@quiz/shared';
import type { ApiError } from '../lib/api.js';
import { Screen, Card, Button } from '../components/ui.js';

/**
 * What an ejected player sees. It says so plainly and gives them the reason the
 * manager typed, because the alternative -- an app that just stops working -- is
 * the version that sends them back to the bar to complain.
 */
export function RemovedScreen({ fatal, onReset }: { fatal: ApiError; onReset: () => void }) {
  const wasRemoved = fatal.code === ErrorCodes.PLAYER_REMOVED;

  return (
    <Screen>
      <div className="flex flex-1 flex-col justify-center gap-4">
        <Card className="text-center">
          <p className="text-2xl font-bold">
            {wasRemoved ? "You're out of this quiz" : 'Your session has ended'}
          </p>
          <p className="mt-3 text-muted">{fatal.message}</p>
          {wasRemoved && (
            <p className="mt-3 text-sm text-muted">
              If that looks wrong, have a word with the staff &mdash; they can put you
              straight back in.
            </p>
          )}
        </Card>
        <Button variant="ghost" onClick={onReset}>
          Back to the start
        </Button>
      </div>
    </Screen>
  );
}
